const styles = theme => ({
  collectionToolBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  viewAllText: {
    fontSize: '12px',
    color: '#919EAB',
    fontWeight: 400,
    cursor: 'pointer',
  },
})

export default styles
